import { useEffect, useState } from "react";

import styles from "./Dashboard.module.scss";

import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Grid from "../../components/Grid";
import { apiRequest } from "../../utils/api";

import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import InfoIcon from "@material-ui/icons/InfoRounded";
import { useTranslation } from "react-i18next";
import BarChart from "../../components/BarChart";
import Compliments from "../../components/Compliments";
import DashboardMetrics from "../../components/DashboardMetrics";
import RadialChart from "../../components/RadialChart";
import { getLocalValue } from "../../utils/auth";
const XlsxTooltip = withStyles((theme) => ({
  tooltip: {
    backgroundColor: 'white',
    color: 'rgba(0, 0, 0, 0.87)',
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #9e9e9e',
    boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)',
  },
}))(Tooltip);
const PersonalDashBoard = () => {
  const { t } = useTranslation();
  const [filterValue, setFilterValue] = useState(["monthly"]);
  const coach_id = getLocalValue("uid");
  const filterBy = ["monthly", "quarterly", "yearly"];
  const [complimentLike, setComplimentLike] = useState(0);

  const handleChange = event => {
    setFilterValue(event.target.value);
  };

  const [metricsValue, setMetricsValue] = useState(null);
  const [coacheemetricsValue, setCoacheeMetricsValue] = useState(null);
  useEffect(() => {
    // get Team Dashboard Calendar details
    apiRequest
      .get(
        `/api/getPersonalDashboardMetrics?coachee_id=${coach_id}&filter=${filterValue}`
      )
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setMetricsValue(data);
        }
      })
      .catch(error => { });
  }, [filterValue]);

  useEffect(() => {
    apiRequest
      .get(`/api/getcoacheeSessionMatrics?uid=${coach_id}`)
      .then(response => {
        if (response.status === 200) {
          const data = response.data.data;
          setCoacheeMetricsValue(data);
        }
      })
      .catch(error => { });
  }, []);

  return (
    <div className={styles.detailsContainer}>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead} ${styles.bold}`}>
          {t("dashboard.personal.personalmetricsHead")}
        </h4>
        {coacheemetricsValue && <DashboardMetrics data={coacheemetricsValue} />}
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.personal.showResultFor")}
          <Select
            className={styles.sectionFilter}
            value={filterValue}
            onChange={handleChange}
            input={<Input />}
            IconComponent={ExpandMoreIcon}
          >
            {filterBy.map(filter => (
              <MenuItem key={filter} value={filter}>
                {filter}
              </MenuItem>
            ))}
          </Select>
        </h4>

        <Grid>
          <RadialChart
            theme={"#D55757"}
            percentage="80"
            title={t("dashboard.personal.happiness")}
            label={`${t(
              "dashboard.personal.ratedSession"
            )} <span>({{chartValue}})</span> / Unrated session <span>({{secondParam}})</span> /  ${t(
              "dashboard.personal.totalSession"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getPersonalHappinessDetails?coachee_id=${coach_id}&filter=${filterValue}`}
            average="average_rated_sessions"
            totalValue="total_sessions"
            secondParam="total_unrated_sessions"
            chartValue="total_rated_sessions"
          />
          <RadialChart
            theme={"#FF9C12"}
            title={t("dashboard.personal.complimentLikes")}
            label={`${t(
              "dashboard.personal.likes"
            )} <span>({{chartValue}})</span> / ${t(
              "dashboard.personal.totalComplements"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getPersonalComplimentDetails?coachee_id=${coach_id}&filter=${filterValue}`}
            average="average_liked_compliments"
            totalValue="total_compliments"
            chartValue="total_liked_compliments"
            updateChart={complimentLike}
          />
          <RadialChart
            theme={"#13C77A"}
            percentage="73"
            title={t("dashboard.personal.success")}
            label={`${t(
              "dashboard.personal.passRate"
            )} <span>({{chartValue}})</span> / ${t(
              "dashboard.personal.totalSubjects"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getPersonalSuccessDetails?coachee_id=${coach_id}&filter=${filterValue}`}
            responseKey=""
            average="average_success"
            totalValue="total_coached_subject"
            chartValue="total_passed_subject"
          />
          <RadialChart
            theme={"#13C77A"}
            percentage="73"
            title={t("dashboard.personal.kpisuccess")}
            label={`${t(
              "dashboard.personal.passRate"
            )} <span>({{chartValue}})</span> / ${t(
              "dashboard.personal.totalSubjects"
            )} <span>({{totalValue}})</span>`}
            frequency={filterValue}
            api={`getPersonalSuccessDetails?coachee_id=${coach_id}&filter=${filterValue}`}
            responseKey=""
            average="average_target_kpi_success"
            totalValue="totalKpiSubjects"
            chartValue="kpi_success_rate"
          />
        </Grid>
      </div>

      <div className={styles.row}>
        <h4 className={`${styles.sectionHead} ${styles.bold}`}>
          {t("dashboard.personal.latestCompliments")}
        </h4>
        <Compliments
          handleLikeCallback={() => setComplimentLike(complimentLike + 1)}
          filter={filterValue}
        />
      </div>
      <div className={styles.row}>
        <h4 className={`${styles.sectionHead}`}>
          {t("dashboard.personal.comparedToTeamAvg")}
        </h4>
        {metricsValue ? (
          <Grid>
            <BarChart
              title={t("dashboard.personal.mostCoachedSubjects")}
              colors={["#13C77A", "#8FDEB2"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                t("dashboard.personal.individual"),
                <span>
                  {t("dashboard.personal.teamAverage")}{" "}

                  <XlsxTooltip
                    arrow
                    title={t("dashboard.tooltip.teamAverage")}
                    placement="right"
                  >
                    <InfoIcon
                      className={styles.infoIcon}
                      fontSize="small"
                    ></InfoIcon>
                  </XlsxTooltip>
                </span>,
              ]}
              responseKeyPrimary="individual"
              responseKeySecondary="team"
              maxValue={metricsValue.max_value}
              data={metricsValue.most_coached_subjects}
              labelX={t("dashboard.personal.subjects")}
              labelY={t("dashboard.personal.session")}
              hasFilter
            />
            <BarChart
              title={t("dashboard.personal.mostFailedSubjects")}
              colors={["#C73426", "#E99A95"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                t("dashboard.personal.individual"),
                <span>
                  {t("dashboard.personal.teamAverage")}{" "}

                  <XlsxTooltip
                    arrow
                    title={t("dashboard.tooltip.teamAverage")}
                    placement="right"
                  >
                    <InfoIcon
                      className={styles.infoIcon}
                      fontSize="small"
                    ></InfoIcon>
                  </XlsxTooltip>
                </span>,
              ]}
              responseKeyPrimary="individual"
              responseKeySecondary="team"
              maxValue={metricsValue.max_value}
              data={metricsValue.most_failed_subjects}
              labelX={t("dashboard.personal.subjects")}
              labelY={t("dashboard.personal.session")}
              hasFilter
            />
            <BarChart
              title={t("dashboard.personal.topSkillsToImprove")}
              colors={["#2B7EFB", "#C5DAFA"]}
              fontColors={["#212121", "#212121"]}
              legends={[
                t("dashboard.personal.individual"),
                <span>
                  {t("dashboard.personal.teamAverage")}{" "}

                  <XlsxTooltip
                    arrow
                    title={t("dashboard.tooltip.teamAverage")}
                    placement="right"
                  >
                    <InfoIcon
                      className={styles.infoIcon}
                      fontSize="small"
                    ></InfoIcon>
                  </XlsxTooltip>
                </span>,
              ]}
              responseKeyPrimary="individual"
              responseKeySecondary="team"
              maxValue={metricsValue.max_value}
              data={metricsValue.top_skills_improve}
              labelX={t("dashboard.personal.subjects")}
              labelY={t("dashboard.personal.session")}
              hasFilter
            />
          </Grid>
        ) : (
          <div>{t("dashboard.noDataYet")}</div>
        )}
      </div>
    </div>
  );
};

export default PersonalDashBoard;